export const EDIT_ITEM_URL_WITH_ANCHOR = (id: number, anchor: string) =>
  `/items/${id}/edit#${anchor}`
